import React, { useEffect, useMemo } from 'react';

import Card from 'Components/Atoms/Card';
import Tabs, { ITab } from 'Components/Molecules/Tabs';
import { useMarketplaces } from 'Hooks/marketplaces';
import ChargeVendorSettings from '../ChargeVendorSettings';

const ChargeVendors: React.FC = () => {
  const { indexMarketplaces, marketplaces } = useMarketplaces();

  useEffect(() => {
    indexMarketplaces();
  }, [indexMarketplaces]);

  const tabs = useMemo<ITab[]>(() => {
    return marketplaces.map(marketplace => ({
      title: marketplace.name,
      component: <ChargeVendorSettings marketplace={marketplace} />,
    }));
  }, [marketplaces]);

  return (
    <Card title="Billings settings">
      <Tabs tabs={tabs} />
    </Card>
  );
};

export default ChargeVendors;
